/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/View',
        'assets/js/common/router/index',
        'assets/js/modules/assets',
        'assets/js/modules/utils',
        'assets/js/modules/widgets/gallery/model/templateModel'
    ],
    function($, _, View, router, assets, utils, TemplateModel) {
        /**
         * @type {number}
         */
        var TITLE_MAX_LENGTH = 27;

        return View.extend({
            /**
             * @inheritdoc
             */
            initialize: function(options) {
                this.template = this.getTemplate();
                this.renderLinks = options.renderLinks || false;
                this.designGallery = options.designGallery || '';
            },

            /**
             * @return {TemplateView}
             */
            render: function() {
                var frontImage =
                    this.model.get('frontImage') || assets.generate('bundles/opensoftonpweb/images/design_gallery/no_thumbnail.png');
                var alt = this.model.get('title') || 'No Title';
                var title = this.model.get('title') || 'Use this design';
                title = utils.truncate(title, TITLE_MAX_LENGTH);

                this.$el.html(
                    this.template({
                        id: this.model.get('id'),
                        frontImage: frontImage,
                        backImage: this.model.get('backImage'),
                        alt: alt,
                        title: title,
                        shape: this.model.get('shape') === TemplateModel.SHAPE_CIRCLE ? 'template-shape-circle' : '',
                        url: this.renderLinks
                            ? router.generate('/{gallery}/create/{slug}', { slug: this.model.get('template'), gallery: this.designGallery })
                            : '#'
                    })
                );

                return this;
            },

            /**
             * @return string
             */
            getTemplate: function() {
                return _.template(
                    [
                        '<div class="gallery-template-block <%- shape %>" data-template-id="<%- id %>">',
                        '<div class="image-block">',
                        '<div class="gallery-template-image">',
                        '<% if (backImage) { %>',
                        '<div class="back-image">',
                        '<a href="#" class="template-image-link"><img  alt="" src="<%- backImage %>" class="image"></a>',
                        '</div>',
                        '<% } %>',
                        '<div class="front-image">',
                        '<a href="<%- url %>" class="template-image-link"><img alt="<%- alt %>" src="<%- frontImage %>" class="image"></a>',
                        '</div>',
                        '</div>',
                        '</div>',
                        '<div class="gallery-template-title">',
                        '<a href="<%- url %>" title="<%- title %>">',
                        '<%- title %> &rsaquo;',
                        '</a>',
                        '</div>',
                        '</div>'
                    ].join('')
                );
            }
        });
    }
);
